import { makeStyles } from '@fluentui/react-components';

import { customTokens } from 'src/utils/theme';

export const useAccreditedBadgeStyles = makeStyles({
  accreditedImgWrapper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  accreditedImg: {
    width: '64px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  accreditedImgLabel: {
    fontSize: customTokens.fontSizeBase100,
    fontWeight: customTokens.fontWeightMedium,
    lineHeight: customTokens.lineHeightBase100,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    marginTop: customTokens.spacingVerticalXS,
  },
});
